import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { uiActions } from "../../store";
import PopUpModal from "../PopUpModal/PopUpModal";
import RoomSceneList from "../RoomSceneList/RoomSceneList";
import styles from "./ViewInRoomModal.module.css";

export default function ViewInRoomModal() {
    const dispatch = useDispatch();
    const [filters, setFilters] = useState([]);
    const [activeFilter, setActiveFilter] = useState('All');

    useEffect(() => {
        const URL = 'https://lizard.chameleonpower.com/CDN/RoomScenes/9705.json';
        fetch(URL)
            .then((response) => response.json())
            .then((data) => {
                // Extract unique descriptions for filters
                const descriptions = [...new Set(data.map(scene => scene.description).filter(desc => desc))];
                setFilters(['All', ...descriptions.sort()]);
            })
            .catch((error) => {
                console.error('Error fetching room scenes:', error);
            });
    }, []);

    const handleClose = () => {
        dispatch(uiActions.setViewInRoomModalActive(false));
    };

    const handleFilterClick = (filter) => {
        setActiveFilter(filter);
    };

    return (
        <PopUpModal handleClose={handleClose}>
            <div className={styles.mainContent}>
                <h1>Choose a Scene</h1>
                
                <div className={styles.filterContainer}>
                    {filters.map(filter => (
                        <button
                            key={filter}
                            className={`${styles.filterButton} ${activeFilter === filter ? styles.active : ''}`}
                            onClick={() => handleFilterClick(filter)}
                        >
                            {filter}
                        </button>
                    ))}
                </div>

                <div className={styles.sceneContainer}>
                    <RoomSceneList 
                        seriesId="9705" 
                        thumbnailSize="256"
                        filterDescription={activeFilter === 'All' ? null : activeFilter}
                    />
                </div>
            </div>
        </PopUpModal>
    );
}